import { injectable } from "tsyringe";
import { HandoverV2ApiRepository } from "@/app/infrastructures/repositories/api/HandoverV2ApiRepository";
import { HandoverV2DetailParams } from "@/data/payload/api/HandoverV2ApiRequest";

@injectable()
export class HandoverV2Presenter {
  private repository: HandoverV2ApiRepository;

  constructor(repo: HandoverV2ApiRepository) {
    this.repository = repo;
  }

  public async getDetailHandover(params: HandoverV2DetailParams) {
    return this.repository.getDetailHandover(params);
  }
}
